import { z } from 'zod';
import { VendorRatesSchema } from '../base/vendor.js';
import { serviceEventType, TarpulatorEntityTypeName, TarpulatorServiceEventBaseSchema, } from './service.js';
export const tarpulatorVendorRatesEventType = (eventName) => serviceEventType(TarpulatorEntityTypeName.vendorRates, eventName);
export const TarpulatorVendorRatesEventTypeNameSchema = z.enum(['created', 'deleted', 'updated']);
export const TarpulatorVendorRatesEventTypeName = TarpulatorVendorRatesEventTypeNameSchema.enum;
export const TarpulatorVendorRatesEventSchema = TarpulatorServiceEventBaseSchema.extend(z.object({
    type: tarpulatorVendorRatesEventType(),
    vendorRates: z.unknown(),
}).shape);
export const TarpulatorVendorRatesCreatedEventSchema = TarpulatorVendorRatesEventSchema.extend(z.object({
    type: tarpulatorVendorRatesEventType(TarpulatorVendorRatesEventTypeName.created),
    vendorRates: VendorRatesSchema,
}).shape);
export const TarpulatorVendorRatesUpdatedEventSchema = TarpulatorVendorRatesEventSchema.extend(z.object({
    type: tarpulatorVendorRatesEventType(TarpulatorVendorRatesEventTypeName.updated),
    vendorRates: VendorRatesSchema,
}).shape);
export const TarpulatorVendorRatesDeletedEventSchema = TarpulatorVendorRatesEventSchema.extend(z.object({
    type: tarpulatorVendorRatesEventType(TarpulatorVendorRatesEventTypeName.deleted),
    vendorRates: VendorRatesSchema,
}).shape);
